module.exports = __webpack_public_path__ + "static/media/ic-cart-open.a0cba1bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-cart-open.svg
// module id = 607
// module chunks = 14